import { cn } from "../lib/utils";

/**
 * Links to imprint, privacy policy, terms, withdrawal notice and the cancellation
 * page – on every public and signed-in page. "Verträge hier kündigen" is the
 * wording § 312k BGB requires.
 */
export function LegalLinks({ className }: { className?: string }) {
  return (
    <nav
      aria-label="Rechtliches"
      className={cn(
        "flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-zinc-500",
        className,
      )}
    >
      <a href="/impressum" className="hover:text-zinc-900">
        Impressum
      </a>
      <a href="/datenschutz" className="hover:text-zinc-900">
        Datenschutz
      </a>
      <a href="/nutzungsbedingungen" className="hover:text-zinc-900">
        AGB
      </a>
      <a href="/widerruf" className="hover:text-zinc-900">
        Widerruf
      </a>
      <a href="/kuendigen" className="hover:text-zinc-900">
        Verträge hier kündigen
      </a>
    </nav>
  );
}
